// Matches the email subaddress used by the account-portal e2e signup test.
// Mirrors apps/user-mgmt/src/utils/is-e2e-test-signup-email.ts — duplicated
// rather than shared via a lib to keep the regex inline-readable in both
// apps and avoid a one-line shared utility.
const E2E_TEST_SIGNUP_EMAIL_REGEX =
  /^testing\.framework\+e2e-signup-.*@reveliolabs\.com$/;

export const isE2eTestSignupEmail = (
  email: string | undefined | null
): boolean =>
  typeof email === 'string' && E2E_TEST_SIGNUP_EMAIL_REGEX.test(email);
